export default "__VITE_ASSET__ChRdKijd__"